import { apiClient } from './api';

export type GetStatsParams = {
  startDate?: string;
  endDate?: string;
  year?: number;
  company?: string;
};

export type SummaryStats = {
  totalBols: number;
  totalAmount: number;

  inProgressBols: number;
  inProgressAmount: number;

  pendingApprovalsBols: number;
  pendingApprovalsAmount: number;

  approvedBols: number;
  approvedAmount: number;

  paidBols: number;
  paidAmount: number;

  unpaidBols: number;
  unpaidAmount: number;

  pendingBols: number;
  pendingAmount: number;

  todayDelivery: number;
};

export type MonthlyStat = {
  month: string;
  totalAmount: number;
  totalBols: number;
};

export type MonthlyInvoiceStat = {
  month: string;
  pendingQty: number;
  pendingValue: number;
  doneQty: number;
  doneValue: number;
};

export type StatsResponse = {
  filters: {
    startDate: string;
    endDate: string;
    year: number;
    company: string | null;
  };
  summary: SummaryStats;
  charts: {
    monthlyStats: MonthlyStat[];
    monthlyInvoiceStats: MonthlyInvoiceStat[];
  };
};

/**
 * Fetch dashboard statistics.
 * Token and headers are handled inside apiClient.
 */
export const getDashboardStats = async (payload: GetStatsParams) => {
  const result = await apiClient.post<{
    message: string;
    data: StatsResponse;
  }>('/stats/info', payload);

  return result.data;
};